import cn from 'classnames';

import styles from './ThreeDotsContent.module.scss';

export const ThreeDotsLoaderContent = ({ className, ...props }: React.ComponentProps<'div'>) => {
  return (
    <div className={cn(className, 'three-dots-loader', styles.loader)} {...props}>
      <span className="sr-only">Loading</span>
    </div>
  );
};
